var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "360_black_24dp 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4737 7.68457C6.95369 7.68457 2.47369 9.92457 2.47369 12.6846C2.47369 14.9246 5.41369 16.8146 9.47369 17.4546V20.6846L13.4737 16.6846L9.47369 12.6846V15.4146C6.32369 14.8546 4.47369 13.5146 4.47369 12.6846C4.47369 11.6246 7.51369 9.68457 12.4737 9.68457C17.4337 9.68457 20.4737 11.6246 20.4737 12.6846C20.4737 13.4146 19.0137 14.5746 16.4737 15.2146V17.2646C20.0037 16.4946 22.4737 14.7346 22.4737 12.6846C22.4737 9.92457 17.9937 7.68457 12.4737 7.68457V7.68457Z",
    fill: "#1E428A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIcon);
export default __webpack_public_path__ + "static/media/RotateIcon.0f1473739fef4d7032d21f01ba5fb1c7.svg";
export { ForwardRef as ReactComponent };